import AnnotationContainer from '../../annotations/AnnotationContainer'
import VideoContainer from '../../annotations/VideoContainer'
import CircleJoystick from '../../joystick/CircleJoystick'
import {MeshContainer} from "../../annotations/ts/MeshContainer";
import {CameraNavMeshHandler} from "../../three-gltf-loader/ts/CameraNavMeshHandler";
import {VideoMeshButtonContainer} from "../../annotations/ts/VideoMeshButtonContainer";

enum MouseClickTarget {
    NONE,
    Annotation,
    Video,
    Joystick,
    FPSNavigation,
    PaintingMesh,
    NAVMESH,
    VideoMeshBtn
}

class NavigationManager {

    private mouseTarget:MouseClickTarget = MouseClickTarget.NONE;
    private _isLocked:boolean = false;

    constructor(private annotationContainer: AnnotationContainer,
                private videoContainer: VideoContainer,
                private meshContainer: MeshContainer,
                private joystick: CircleJoystick,
                private cameraNavMeshHandler:CameraNavMeshHandler,
                private videoMeshButtonContainer: VideoMeshButtonContainer
    ) {
        window.addEventListener("mousedown",this.onDocumentMouseMove,{passive:false});
        window.addEventListener("dblclick",this.onDocumentMouseDbClick,{passive:false});
    }

    onDocumentMouseDbClick = (evt:MouseEvent) => {
        if ( this._isLocked) {
            return ;
        }
        if (this.meshContainer.onDocumentMouseMove(evt)) {
            if ( !this._isLocked) {
                this.mouseTarget = MouseClickTarget.PaintingMesh;
                this.joystick.resetMouseThumb();
            }
        }
        else {
            const navMeshHitPoint = this.cameraNavMeshHandler.onMouseDbClick(evt);
            if (navMeshHitPoint) {
                if (!this.isLocked) {
                    this.mouseTarget = MouseClickTarget.NAVMESH;
                    this.joystick.resetMouseThumb();
                    this.cameraNavMeshHandler.navigateToNanMeshPoint(navMeshHitPoint);

                }
            }
        }
    }

    onDocumentMouseMove = (evt: MouseEvent) => {

        if ( this._isLocked) {
            return ;
        }

        if (this.annotationContainer.onDocumentMouseMove(evt)) {
            if ( !this._isLocked) {  //in case onDocumentMouseMove set the _isLocked to true or false before it returns
                this.mouseTarget = MouseClickTarget.Annotation;
                this.joystick.resetMouseThumb();
            }

        }
        else if (this.videoContainer.onDocumentMouseMove(evt)) {
            if ( !this._isLocked) {
                this.mouseTarget = MouseClickTarget.Video;
                this.joystick.resetMouseThumb();
            }
        }
        else if (this.videoMeshButtonContainer.onDocumentMouseMove(evt)) {
            if (!this._isLocked) {
                this.mouseTarget = MouseClickTarget.VideoMeshBtn;
                this.joystick.resetMouseThumb();

            }
        }
    }

    public blockEvents = () => {
        this._isLocked = true;
    }

    public unBlockEvents = () => {
        this._isLocked = false;
    }

    get isLocked() {
        return this._isLocked;
    }
}

export default NavigationManager;
